import request from '@/utils/request'


export function getContactList(data) {
  return request({
    url: '/api/common/v1/contact/list',
    method: 'post',
    data
  })
}

export function addContact(data) {
  return request({
    url: '/api/common/v1/contact/add',
    method: 'post',
    data
  })
}

export function removeContact(data) {
  return request({
    url: '/api/common/v1/contact/remove',
    method: 'post',
    data
  })
}

export function updataContact(data) {
  return request({
    url: '/api/common/v1/contact/updataContact',
    method: 'post',
    data
  })
}

export function downloadContactExcelApi(data) {
  return request({
    url: '/api/common/v1/contact/excelContactExport',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

export const tempLinkAddress = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "common/fileTemplate/ImportContactExample.xlsx"

export function removes(data) {
  return request({
    url: '/api/common/v1/contact/removes',
    method: 'post',
    data
  })
}

